import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';
import * as THREE from 'three';

const SHADOW_CAMERA_EXTENT = 14;

export default function Lights() {
  const { gl } = useThree();

  useEffect(() => {
    gl.toneMapping = THREE.ACESFilmicToneMapping;
  }, [gl]);

  return (
    <>
      {/* Three-Point Lighting Setup for character at [0, 0.5, 0] */}
      {/* Soft general light */}
      <ambientLight intensity={0.25 * 5} />

      {/* Key Light */}
      <directionalLight
        position={[-2, 4, 2]} // Slightly above and to the side
        intensity={0.8 * 3} // Bright but not overpowering
        castShadow={true}
        // TODO: May need to decrease this size on mobile
        shadow-mapSize-width={4096}
        shadow-mapSize-height={4096}
        shadow-camera-left={-SHADOW_CAMERA_EXTENT}
        shadow-camera-right={SHADOW_CAMERA_EXTENT}
        shadow-camera-top={SHADOW_CAMERA_EXTENT}
        shadow-camera-bottom={-SHADOW_CAMERA_EXTENT}
        shadow-camera-near={0.1}
        shadow-camera-far={50}
        shadow-normalBias={0.1}
        shadow-bias={-0.0001}
      />

      {/* Fill Light */}
      <pointLight
        position={[-1, 0.5, 1]} // On the opposite side of the key light, lower
        intensity={0.4} // Less intense than the key light
      />

      {/* Back Light (Rim Light) */}
      <spotLight
        intensity={0.6}
        position={[0, 2, -2]} // Behind and above the character
        angle={Math.PI / 4}
        penumbra={0.5} // Soft edge to the light
      />

      {/* Character looks dark when the environment is on */}
      {/* <Environment background={false} files="meadow_2_1k_16bit.exr" path="/" /> */}
    </>
  );
}
